export default __webpack_public_path__ + "static/media/28.02fa630b.png";